import { Link } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";
import { pickRelatedLinks } from "@/lib/related-links";

/**
 * "Fortsätt här" – ämnesmatchade interna länkar i slutet av en artikel.
 * Renderas server-side (inga effekter) så crawlers ser länkarna direkt.
 */
export function RelatedLinks({
  keyId,
  text,
  currentHref,
  max = 6,
  heading = "Fortsätt här",
  className = "",
}: {
  keyId: string;
  text: string;
  currentHref?: string;
  max?: number;
  heading?: string;
  className?: string;
}) {
  const links = pickRelatedLinks(keyId, text, { currentHref, max });
  if (links.length === 0) return null;

  return (
    <section className={`mt-14 ${className}`} aria-labelledby="relaterat">
      <p className="eyebrow">Relaterat</p>
      <h2 id="relaterat" className="mt-2 font-display text-2xl md:text-3xl">
        {heading}
      </h2>
      <ul className="mt-6 grid gap-3 sm:grid-cols-2">
        {links.map((l) => (
          <li key={l.href}>
            <Link
              to={l.href}
              className="group flex min-h-[68px] items-start justify-between gap-3 rounded-2xl border border-border bg-card px-4 py-3.5 transition hover:border-accent/50 hover:bg-secondary/50"
            >
              <span className="min-w-0">
                <span className="block font-display text-[15px] leading-snug group-hover:text-accent">
                  {l.label}
                </span>
                <span className="mt-1 block text-xs leading-snug text-muted-foreground">
                  {l.note}
                </span>
              </span>
              <ArrowUpRight
                size={15}
                className="mt-0.5 shrink-0 text-muted-foreground transition group-hover:text-accent"
              />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
